const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Link = require("../core/view/Link");
const BALogoText = require("./BALogoText");
const URLMake = require("../../shared/URLMake");
const AssetsUtil = require("../core/util/AssetsUtil");

const styles = require("./styles/HelpMonster.css");

module.exports = createReactClass({
	displayName: "HelpMonster",

	propTypes: {
		pageType: PT.oneOf(["faq", "support"]).isRequired,
	},

	render: function() {
		const {pageType} = this.props;

		const monsterClass = pageType;

		const helpContents = mainClass => (
			<Link to={URLMake.forContact()} className={mainClass}>
				<div className={styles.helpImgFallback} />
				<div className={styles.helpBox} />
				<div className={styles.helpImgContainer}>
					<div className={styles.helpImgAspectContainer}>
						<img
							className={styles.helpImg}
							alt=""
							src={AssetsUtil.getOfficeElement("faq-help")}
						/>
					</div>
				</div>
				<div className={styles.helpContent}>
					<div className={styles.helpText}>
						<div className={styles.helpTitle}>Need Help?</div>
						<div className={styles.helpSub}>
							{"Click here to ask "}
							<BALogoText color="white" alwaysLogo />
						</div>
					</div>
					<div className={styles.circleOuter}>
						<div className={styles.helpCircle}>
							<img
								className={styles.helpArrow}
								alt="Ask BA"
								src={AssetsUtil.getOfficeElement("arrow-right-red")}
							/>
						</div>
					</div>
				</div>
			</Link>
		);

		return (
			<div className={styles[monsterClass]}>
				{helpContents(styles.helpDesktop)}
				{helpContents(styles.helpMobile)}
			</div>
		);
	},
});
